import { BrandType } from 'models/brand.model';
import { LocationType } from 'models/cokitchen.model';
import { MealType } from 'models/meal.model';
import {
  CalculatedOrderType,
  CreateGroupOrderType,
  CreateOrderObjectType,
  OrderMealType,
  OrderObjectType,
  OrderTypesType
} from 'models/order.model';
import { createContext, useContext } from 'react';

export type OrdersContextType = {
  restaurants: BrandType[];
  restaurantsLoading: boolean;
  loadRestaurants: () => void;
  restaurant: BrandType | null;
  restaurantLoading: boolean;
  loadRestaurant: (id?: string) => void;
  bulkOrderMeals: OrderMealType[];
  setBulkOrderMeals: (meals: OrderMealType[]) => void;
  batchOrderMeals: OrderMealType[];
  setBatchOrderMeals: (meals: OrderMealType[]) => void;
  groupOrderMeals: OrderMealType[];
  setGroupOrderMeals: (meals: OrderMealType[]) => void;
  meal: MealType | null;
  mealLoading: boolean;
  loadMeal: (id?: string) => void;
  createGroupOrderObject: CreateGroupOrderType;

  setCreateGroupOrderObject: (
    args: (prevState: CreateGroupOrderType) => CreateGroupOrderType
  ) => void;
  calculatedOrderForm: OrderObjectType;
  setcalculatedOrderForm: (arg: OrderObjectType) => void;
  calculatedOrder: CalculatedOrderType;
  setCalculatedOrder: (arg: CalculatedOrderType) => void;
  createOrderForm: CreateOrderObjectType;
  setCreateOrderForm: (arg: CreateOrderObjectType) => void;
  cokitchenPolygon: LocationType;
  setCokitchenPolygon: (arg1: LocationType) => void;
  orderType: OrderTypesType[];
  setOrderType: (arg1: OrderTypesType[]) => void;
  currentAddress: string;
  saveAddressloading: boolean;
  currentAddressLoading: boolean;
  handleSaveAddress: (address: string, name: string) => Promise<void>;
  setCoordinates: ({ lat, lng }: { lat: string; lng: string }) => void;
  locationAccess: boolean;
  calculatedOrderLoading: boolean;
  setCalculatedOrderLoading: (value: boolean) => void;
  handleReset: () => void;
  deliveryDate: string;
  setDeliveryDate: (arg: string) => void;
  confirmedQuickeats: boolean;
  setConfirmedQuickeats: (arg: boolean) => void;
};

export const OrdersContext = createContext({} as OrdersContextType);

const useOrdersContext = () => {
  const context = useContext(OrdersContext);
  return context;
};

export default useOrdersContext;
